import { useMutation } from '@tanstack/react-query';
import type {
  CreateLabTestRequestT,
  CreateLabTestResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { fetchCreateLabTest } from '../api/createLabTest.js';

export interface CreateLabTestVariables {
  data: CreateLabTestRequestT;
}

export function useCreateLabTestMutation() {
  return useMutation({
    mutationKey: ['labs', 'create-lab-test'],
    mutationFn: async ({ data }: CreateLabTestVariables): Promise<CreateLabTestResponseT> => {
      return await fetchCreateLabTest(data);
    },
  });
}
